export default __webpack_public_path__ + "static/media/cityserve-logo-white.c7073481.png";